import { supabase } from './supabase';

export async function fetchPageCopy(page) {
  const { data } = await supabase
    .from('site_settings')
    .select('key, value')
    .like('key', `copy_${page}_%`);
  const result = {};
  if (data) {
    data.forEach(r => {
      result[r.key.slice(`copy_${page}_`.length)] = r.value;
    });
  }
  return result;
}
